import { call, put, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import * as types from 'constants/ActionTypes';
import { createNotification } from 'modules/toast-notifications/actions';

import * as interventionMediaAction from './actions';

function* updateMediasOrder({ payload, meta }) {
  const { request } = payload;
  try {
    yield call(restClient.request, request);
    yield put(interventionMediaAction.updateMediasOrderSuccess(meta));
  } catch (error) {
    yield put(interventionMediaAction.updateMediasOrderFailure(error, meta));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'http.error.message',
          defaultMessage: 'An error occurred',
        },
      })
    );
  }
}

export default function* interventionMediaSagas() {
  yield takeLatest(types.UPDATE_INTERVENTION_MEDIA_ORDER_REQUEST, updateMediasOrder);
}
